// Zdjęcie do zapisu przez API (wniosek o urządzenie, przepis): zmniejszone na telefonie (dłuższy bok 1600 px, JPEG),
// jako base64 w treści JSON (zapisy API tylko JSON - obrona przed CSRF). Idzie szybko i mieści się w limicie serwera.
async function zmniejsz(plik: File): Promise<Uint8Array> {
  const bitmapa = await createImageBitmap(plik);
  const skala = Math.min(1, 1600 / Math.max(bitmapa.width, bitmapa.height));
  const plotno = document.createElement("canvas");
  plotno.width = Math.round(bitmapa.width * skala);
  plotno.height = Math.round(bitmapa.height * skala);
  plotno.getContext("2d")?.drawImage(bitmapa, 0, 0, plotno.width, plotno.height);
  const blob = await new Promise<Blob | null>((ok) => plotno.toBlob(ok, "image/jpeg", 0.85));
  return new Uint8Array(await (blob ?? plik).arrayBuffer());
}

/** Bajty jako base64 (porcjami - `fromCharCode` z milionem argumentów przepełnia stos); też obraz firmware w panelu. */
export function base64(b: Uint8Array): string {
  let s = "";
  for (let i = 0; i < b.length; i += 0x8000) s += String.fromCharCode(...b.subarray(i, i + 0x8000));
  return btoa(s);
}

export async function zdjecieBase64(plik: File): Promise<string> {
  return base64(await zmniejsz(plik));
}

/** Załącznik zgłoszenia serwisowego: zdjęcie zmniejszone jak wyżej, PDF (dowód zakupu) i film bez zmian. */
export async function zalacznikBase64(plik: File): Promise<string> {
  if (plik.type === "application/pdf" || plik.type.startsWith("video/")) return base64(new Uint8Array(await plik.arrayBuffer()));
  return zdjecieBase64(plik);
}
